/* ══════════════════════════════════════════════════════
   MARLEYME DEALS — theme.js
   Auto-sync cart with ZenDrop/Shopify. No config needed.
══════════════════════════════════════════════════════ */

/* ── CART DRAWER ──────────────────────────────────────── */
function openCart(){
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart(){
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

/* ── REFRESH CART COUNT ───────────────────────────────── */
function refreshCartCount(){
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('#cart-bubble, #drawer-count').forEach(el => {
        el.textContent = cart.item_count;
      });
      const bubble = document.getElementById('cart-bubble');
      if(bubble){ bubble.classList.add('pop'); setTimeout(()=>bubble.classList.remove('pop'), 300); }
    });
}

/* ── REFRESH DRAWER HTML ──────────────────────────────── */
function refreshDrawer(){
  fetch('/?sections=cart-drawer-items')
    .catch(() => {});
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      refreshCartCount();
      // Reload page-embedded cart if on cart page
      if(window.location.pathname === '/cart') location.reload();
    });
}

/* ── AJAX ADD TO CART ─────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.quick-add-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn       = form.querySelector('.btn-quick-add');
      const addText   = btn.querySelector('.add-text');
      const loadText  = btn.querySelector('.add-loading');
      btn.disabled = true;
      if(addText)  addText.style.display  = 'none';
      if(loadText) loadText.style.display = 'inline';

      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            id:       form.querySelector('[name=id]').value,
            quantity: 1
          })
        });
        if(resp.ok){
          refreshCartCount();
          openCart();
          refreshCartDrawerItems();
          btn.style.background = '#2E7D52';
          if(addText)  addText.textContent = '✓ Added!';
          if(loadText) loadText.style.display = 'none';
          if(addText)  addText.style.display = 'inline';
          setTimeout(() => {
            btn.style.background = '';
            if(addText) addText.textContent = '+ Add to Cart';
            btn.disabled = false;
          }, 2500);
        }
      } catch(err){
        btn.disabled = false;
        if(addText)  addText.style.display  = 'inline';
        if(loadText) loadText.style.display = 'none';
      }
    });
  });

  /* PRODUCT PAGE ADD TO CART */
  const productForm = document.getElementById('product-form');
  if(productForm){
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = document.getElementById('add-to-cart-btn');
      if(!btn) return;
      const orig = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;
      try {
        const formData = new FormData(productForm);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            id:       formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });
        if(resp.ok){
          refreshCartCount();
          refreshCartDrawerItems();
          openCart();
          btn.textContent = '✓ Added to Cart!';
          btn.style.background = '#2E7D52';
          setTimeout(() => {
            btn.textContent = orig;
            btn.style.background = '';
            btn.disabled = false;
          }, 2500);
        }
      } catch(err){
        btn.textContent = orig;
        btn.disabled = false;
      }
    });
  }
});

/* ── REFRESH CART DRAWER ITEMS ────────────────────────── */
async function refreshCartDrawerItems(){
  try {
    const resp = await fetch('/cart.js');
    const cart = await resp.json();
    const container = document.getElementById('drawer-items');
    if(!container) return;
    if(cart.item_count === 0){
      container.innerHTML = '<div class="cart-drawer-empty"><p>🐾 Your cart is empty!</p></div>';
      const emptyFooter = document.getElementById('cart-drawer-footer');
      if(emptyFooter) emptyFooter.style.display = 'none';
      return;
    }
    const footer = document.getElementById('cart-drawer-footer');
    if(footer) footer.style.display = 'block';
    let html = '';
    cart.items.forEach((item, idx) => {
      const img = item.image ? `<img src="${item.image.replace('.jpg','_80x80.jpg')}" alt="${item.title}">` : '<div style="width:72px;height:72px;background:#F5EFE6;border-radius:8px;display:flex;align-items:center;justify-content:center;font-size:32px">🐾</div>';
      html += `<div class="drawer-item">
        ${img}
        <div class="drawer-item-info">
          <p class="drawer-item-title">${item.title}</p>
          ${item.variant_title !== 'Default Title' ? `<p class="drawer-item-variant">${item.variant_title}</p>` : ''}
          <p class="drawer-item-price">${formatMoney(item.price)}</p>
          <div class="drawer-qty">
            <button onclick="updateQty(${idx+1},${item.quantity-1})">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateQty(${idx+1},${item.quantity+1})">+</button>
          </div>
        </div>
        <button class="drawer-remove" onclick="updateQty(${idx+1},0)">🗑</button>
      </div>`;
    });
    container.innerHTML = html;
    const totalEl = document.getElementById('drawer-subtotal');
    if(totalEl) totalEl.textContent = formatMoney(cart.total_price);
    const countEl = document.getElementById('drawer-count');
    if(countEl) countEl.textContent = cart.item_count;
  } catch(err){}
}

/* ── UPDATE CART QTY ──────────────────────────────────── */
function updateQty(line, qty){
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({ line, quantity: qty })
  }).then(() => {
    refreshCartCount();
    refreshCartDrawerItems();
  });
}

/* ── FORMAT MONEY ─────────────────────────────────────── */
function formatMoney(cents){
  return '$' + (cents/100).toFixed(2);
}

/* ── MOBILE NAV ───────────────────────────────────────── */
function toggleMobileNav(){
  document.getElementById('mobile-nav').classList.toggle('open');
}

/* ── SEARCH ───────────────────────────────────────────── */
function toggleSearch(){
  document.getElementById('search-bar').classList.toggle('open');
  if(document.getElementById('search-bar').classList.contains('open')){
    document.querySelector('.search-bar input') && document.querySelector('.search-bar input').focus();
  }
}

/* ── PRODUCT PAGE HELPERS ─────────────────────────────── */
function changeQtyProduct(delta){
  const input = document.getElementById('product-qty');
  if(!input) return;
  const val = Math.max(1, parseInt(input.value) + delta);
  input.value = val;
}

function selectOption(btn, optionName, value){
  document.querySelectorAll(`[data-option="${optionName}"]`).forEach(b => b.classList.remove('selected'));
  btn.classList.add('selected');
  updateVariant();
}

function updateVariant(){
  const select = document.getElementById('variant-select');
  if(!select) return;
  const options = document.querySelectorAll('.option-btn.selected');
  const vals = Array.from(options).map(b => b.dataset.value);
  for(const opt of select.options){
    const varTitle = opt.textContent.trim();
    if(vals.every(v => varTitle.includes(v))){
      opt.selected = true;
      break;
    }
  }
}

/* ── STICKY HEADER SHADOW ─────────────────────────────── */
window.addEventListener('scroll', () => {
  const header = document.getElementById('site-header');
  if(!header) return;
  header.style.boxShadow = window.scrollY > 8
    ? '0 4px 24px rgba(0,0,0,.12)'
    : '0 2px 12px rgba(0,0,0,.06)';
});

/* ── BUY IT NOW ───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  const buyNowBtn = document.getElementById('buy-now-btn');
  if(buyNowBtn){
    buyNowBtn.addEventListener('click', async () => {
      const productForm = document.getElementById('product-form');
      if(!productForm) return;
      buyNowBtn.textContent = 'Loading...';
      buyNowBtn.disabled = true;
      try {
        const formData = new FormData(productForm);
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });
        if(resp.ok){
          window.location.href = '/checkout';
        } else {
          buyNowBtn.textContent = '⚡ Buy It Now';
          buyNowBtn.disabled = false;
        }
      } catch(err){
        buyNowBtn.textContent = '⚡ Buy It Now';
        buyNowBtn.disabled = false;
      }
    });
  }
});

/* ── INIT ─────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', refreshCartCount);
